export enum FileTypeEnum {
    DIA = 'DIA',
    LEGAL_PO = 'LEGAL PO',
  }
